import React from 'react';
import Box from '@mui/material/Box';
import { Container } from '@mui/material';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { isAdminUser } from '../../utilities/helper';

const ProtectedLayout: React.FC = () => {
  const { user, token, isAuthenticated } = useSelector((state: RootState) => state.auth);

  if (!token || !isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (isAdminUser(user)) {
    return <Navigate to="/admin/login" replace />;
  }

  return (
    <Container sx={{ py: 4, bgcolor: '#fbf9fa' }} maxWidth="xl">
      <Box
        sx={{
          flexGrow: 1,
          width: '100%',
        }}
      >
        <Outlet />
      </Box>
    </Container>
  );
};

export default ProtectedLayout;
